module.exports = __webpack_public_path__ + "img/facebook-logo.a658d8f6.png";